















































import {Component, Vue} from 'vue-property-decorator';
import ItemImage from '@/components/ItemImage.vue';
import {CartEvent, cartService} from '../services/cart-service';
import {Item} from "../model";

@Component({components: {ItemImage}})
export default class CartIndicator extends Vue {
  items: number = 0;
  lastItem: Item|null = null;
  flyoutActive: boolean = false;

  created() {
    cartService.subscribe(this.cartUpdated.bind(this));
    let cartItems = cartService.getCart().items;
    this.items = cartItems.length;
    if (cartItems && cartItems.length > 0) {
      this.lastItem = cartItems[this.items -1].item;
    }
  }

  destroyed() {
    cartService.unSubscribe(this.cartUpdated.bind(this));
  }

  // noinspection JSMethodCanBeStatic
  cartUpdated(e: CartEvent): void {
    let oldLength = this.items;
    this.items = e.items.length;
    if (e.items && e.items.length > 0) {
      this.lastItem = e.items[this.items -1].item;
    }
    if (this.items > oldLength) {
      this.showFlyout();
    }
  }

  goToCart() {
    this.closeFlyout();
    this.$router.push('/cart');
  }

  showFlyout() {
    this.flyoutActive = true;
  }

  closeFlyout() {
    this.flyoutActive = false;
  }
}
